import { FlaskConical, TrendingUp, MapPin, Megaphone, Building2 } from "lucide-react";

const tools = [
  { icon: FlaskConical, title: "Stock & detergent tracking", text: "Know exactly how much detergent you use per order and get alerts before you run out." },
  { icon: TrendingUp, title: "Popular services analytics", text: "See which services make you the most money — wash & fold, dry cleaning, express — and push what works." },
  { icon: MapPin, title: "Customer location mapping", text: "A heatmap of where your customers live, so you know where to send pickup agents next." },
  { icon: Megaphone, title: "Promotional insights", text: "Find quiet days and slow hours, then send targeted offers to fill them." },
  { icon: Building2, title: "Branch expansion intelligence", text: "Data-backed answers to \u201cwhere should my next branch be?\u201d — with an expansion readiness score." },
];

export default function Phase2() {
  return (
    <section data-testid="solution-phase2-section" className="bg-[#1B4F72] py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#1B4F72] bg-[#AED6F1] px-4 py-1.5 rounded-full mb-4">The Solution — Phase 2</span>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-2xl">
          Intelligence & Growth: your data starts working for you
        </h2>
        <p className="mt-4 text-lg text-[#AED6F1] leading-relaxed max-w-2xl">
          Once operations are running smoothly, Phase 2 turns your everyday orders into business intelligence:
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((t, i) => (
            <div key={i} data-testid={`phase2-card-${i}`} className="bg-[#0F2B3E] rounded-2xl border border-white/10 p-8 hover:border-[#1ABC9C]/60 transition-colors duration-300">
              <span className="w-12 h-12 rounded-xl bg-[#1ABC9C]/15 flex items-center justify-center mb-5">
                <t.icon className="w-6 h-6 text-[#1ABC9C]" />
              </span>
              <h3 className="font-display text-lg sm:text-xl font-semibold text-white">{t.title}</h3>
              <p className="mt-2 text-base text-[#AED6F1] leading-relaxed">{t.text}</p>
            </div>
          ))}
          <div className="bg-[#1ABC9C] rounded-2xl p-8 flex flex-col justify-center">
            <p className="font-display text-xl sm:text-2xl font-bold text-[#0F2B3E] leading-snug">
              Available in the Pro and Premium plans.
            </p>
            <a href="#pricing" data-testid="phase2-pricing-btn" className="mt-4 inline-flex items-center gap-2 text-white font-bold">
              Compare plans <span aria-hidden="true">&darr;</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
